var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.377 8.324 3.478 1.407l8.777 5.038zM1.678 1C1.272 1.213 1 1.6 1 2.103v13.794c0 .503.272.89.678 1.103l8.02-8.002L1.679 1zm13.29 7.052-1.84-1.066-2.054 2.016 2.053 2.016 1.879-1.066c.562-.447.562-1.453-.038-1.9m-11.49 8.545 8.777-5.038-1.878-1.879z"
  })));
};
export default SvgPlay;